/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/system-sim/system-sim',['require','jquery','core/base-screen','core/engine'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  var BaseScreen = require('core/base-screen');
  var Engine = require('core/engine');

  /*****************************************************************************************************************///}

  var SystemSim = BaseScreen.extend({

  /////////////
  // METHODS /{
  /////////////

    stepIndex: -1,
    delay: 700,

    events: {
      'click .init-spot': 'initHotspot',
      'click .hotspot': 'advanceStep',
      'click .simulation-step img': 'incorrectFeedback'
    },

    initialize: function(options)
    {
      BaseScreen.prototype.initialize.call(this);

      //console.log('System Sim::initialize');
    },

    onShow: function()
    {
      this.playMedia();
    },

    setContent: function()
    {
      BaseScreen.prototype.setContent.apply(this);

      if (!this.content.get('hotspot'))
        this.content.set('hotspot', null);
    },

    onMediaEnded: function(e)
    {
      //console.log('SystemSim::onMediaEnded');

      if (this.media.triggerOnce)
        this.channel.player.unbind($.jPlayer.event.ended);

      var step = this.content.get('steps')[this.stepIndex];

      this.$el.find('.blocker').hide();

      var isNotClickable = (!step && !this.content.get('hotspot')) || (step && !step.hotspot);

      if (isNotClickable) // if no step and no special hotspot OR a step without a hotspot, auto advance
        setTimeout($.proxy(this.advanceStep, this), this.delay);
    },

    initHotspot: function(e)
    {
      $(e.currentTarget).hide();

      this.advanceStep();
    },

    incorrectFeedback: function()
    {
      this.$el.find('.feedback').fadeIn(400).delay(this.delay).fadeOut(400);

      return false;
    },

    advanceStep: function(e)
    {
      // hide step
      this.$el.find('div[data-index=' + this.stepIndex + ']').hide();

      // mark as clicked
      var step = this.content.get('steps')[this.stepIndex];
      if (step)
        step.complete = true;

      // increment stepIndex
      this.stepIndex++;

      this.changeContent();
    },

    changeContent: function()
    {
      var step = this.content.get('steps')[this.stepIndex];

      //console.log('SystemSim::changeContent');
      //console.log(step);

      this.$el.find('.blocker').show();

      if (step)
      {
        this.$el.find('div[data-index=' + this.stepIndex + ']').show();
        this.$el.find('.primary-text').html(step.primary);
        this.$el.find('.directions-text').html(step.directions);

        if (step.audio)
          this.playMedia({ media: step.audio });
        else
          this.$el.find('.blocker').hide();

        if (step.popup)
          Engine.execute('ask.popup.show', step.popup);
      }
      else
      {
        this.$el.find('div[data-index=' + (this.stepIndex - 1) + ']').show();
        setTimeout($.proxy(this.autoAdvance, this), this.delay);
      }
    }

  /*****************************************************************************************************************///}

  });

  return SystemSim;

});

